/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Bookable_MembersInputs */

const en_admin_resource_form_bookable_members = /** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can be booked by members`)
};

const de_admin_resource_form_bookable_members = /** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann von Mitgliedern gebucht werden`)
};

const es_admin_resource_form_bookable_members = /** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puede ser reservado por miembros`)
};

const fr_admin_resource_form_bookable_members = /** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut être réservée par les membres`)
};

const nl_admin_resource_form_bookable_members = /** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan worden gereserveerd door leden`)
};

/** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */
const it_admin_resource_form_bookable_members = en_admin_resource_form_bookable_members;

/** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */
const pt_br2_admin_resource_form_bookable_members = en_admin_resource_form_bookable_members;

/** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */
const pl_admin_resource_form_bookable_members = en_admin_resource_form_bookable_members;

/** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */
const hu_admin_resource_form_bookable_members = en_admin_resource_form_bookable_members;

/** @type {(inputs: Admin_Resource_Form_Bookable_MembersInputs) => LocalizedString} */
const ro_admin_resource_form_bookable_members = en_admin_resource_form_bookable_members;

/**
* | output |
* | --- |
* | "Can be booked by members" |
*
* @param {Admin_Resource_Form_Bookable_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_bookable_members = /** @type {((inputs?: Admin_Resource_Form_Bookable_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Bookable_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_bookable_members(inputs)
	if (locale === "de") return de_admin_resource_form_bookable_members(inputs)
	if (locale === "es") return es_admin_resource_form_bookable_members(inputs)
	if (locale === "fr") return fr_admin_resource_form_bookable_members(inputs)
	if (locale === "nl") return nl_admin_resource_form_bookable_members(inputs)
	if (locale === "it") return it_admin_resource_form_bookable_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_bookable_members(inputs)
	if (locale === "pl") return pl_admin_resource_form_bookable_members(inputs)
	if (locale === "hu") return hu_admin_resource_form_bookable_members(inputs)
	return ro_admin_resource_form_bookable_members(inputs)
});
export { admin_resource_form_bookable_members as "admin.resource_form.bookable_members" }